export default  [
  {
    path: 'loan-origination-settings/general',
    name: 'loan-origination-settings-general',
    meta: {
      // requiredPrivileges:  ['Loan-Pro Settings']
    },
    component: () =>
      import('@/modules/global-settings/loan-origination/views/General.vue')
  },

  // Loan Policy Settings
  {
    path: 'loan-policy-settings/loan-review-checklist',
    name: 'loan-policy-settings-loan-review-checklist',
    meta: {
      // requiredPrivileges:  ['Loan-Pro Settings']
    },
    component: () =>
      import(
        '@/modules/global-settings/loan-origination/views/loan-policies/LoanReviewChecklist.vue'
      )
  },
  {
    path: 'loan-policy-settings/loan-fees',
    name: 'loan-loan-fees',
    meta: {
      // requiredPrivileges:  ['Loan-Pro Settings']
    },
    component: () =>
      import(
        '@/modules/global-settings/loan-origination/views/loan-policies/LoanFees.vue'
      )
  },
  {
    path: 'loan-policy-settings/loan-late-fees',
    name: 'loan-loan-late-fees',
    meta: {
      // requiredPrivileges:  ['Loan-Pro Settings']
    },
    component: () =>
      import(
        '@/modules/global-settings/loan-origination/views/loan-policies/LoanLateFees.vue'
      )
  },
  {
    path: 'loan-policy-settings/loan-types',
    name: 'loan-policy-settings-loan-types',
    meta: {
      // requiredPrivileges:  ['Loan-Pro Settings']
    },
    component: () =>
      import(
        '@/modules/global-settings/loan-origination/views/loan-policies/LoanTypes.vue'
      )
  },
  {
    path: 'loan-policy-settings/loan-products',
    name: 'loan-policy-settings-loan-products',
    meta: {
      // requiredPrivileges:  ['Loan-Pro Settings']
    },
    component: () =>
      import(
        '@/modules/global-settings/loan-origination/views/loan-policies/LoanProducts.vue'
      )
  },
  {
    path: 'loan-policy-settings/loan-reporting-settings',
    name: 'loan-policy-settings-loan-reporting-settings',
    meta: {
      // requiredPrivileges:  ['Loan-Pro Settings']
    },
    component: () =>
      import(
        '@/modules/global-settings/loan-origination/views/loan-policies/LoanReportingSettings.vue'
      )
  },
  {
    path: 'loan-policy-settings/collateral-types',
    name: 'loan-policy-settings/collateral-types',
    meta: {
      // requiredPrivileges:  ['Loan-Pro Settings']
    },
    component: () =>
      import(
        '@/modules/global-settings/loan-origination/views/loan-policies/CollateralTypes.vue'
      )
  },
  {
    path: 'loan-policy-settings/interest-rate',
    name: 'loan-policy-settings/interest-rate',
    meta: {
      // requiredPrivileges:  ['Loan-Pro Settings']
    },
    component: () =>
      import(
        '@/modules/global-settings/loan-origination/views/loan-policies/InterestRate.vue'
      )
  },

  // Security Policies Settings
  {
    path: 'security-policies-settings/loan-waiver',
    name: 'security-policies-settings-loan-waiver',
    meta: {
      // requiredPrivileges:  ['Loan-Pro Settings']
    },
    component: () =>
      import(
        '@/modules/global-settings/loan-origination/views/security-policies/LoanWaiver.vue'
      )
  },
  {
    path: 'security-policies-settings/loan-approval',
    name: 'security-policies-settings-loan-approval',
    meta: {
      requiredPrivileges:  ['Loan-Pro Settings']
    },
    component: () =>
      import(
        '@/modules/global-settings/loan-origination/views/security-policies/LoanApproval.vue'
      )
  },

  // Other Settings

  {
    path: 'other-settings/personal-account-types',
    name: 'other-settings-personal-account-types',
    meta: {
      // requiredPrivileges:  ['Loan-Pro Settings']
    },
    component: () =>
      import(
        '@/modules/global-settings/loan-origination/views/other-settings/PersonalAccountTypes.vue'
      )
  },
  {
    path: 'other-settings/interest-rate-methods',
    name: 'other-settings-interest-rate-methods',
    meta: {
      // requiredPrivileges:  ['Loan-Pro Settings']
    },
    component: () =>
      import(
        '@/modules/global-settings/loan-origination/views/other-settings/InterestRateMethod.vue'
      )
  },
  {
    path: 'other-settings/reporting-sectors',
    name: 'other-settings-reporting-sectors',
    meta: {
      // requiredPrivileges:  ['Loan-Pro Settings']
    },
    component: () =>
      import(
        '@/modules/global-settings/loan-origination/views/other-settings/ReportingSectors.vue'
      )
  },
  {
    path: 'other-settings/dsr-calculation-methods',
    name: 'other-settings-dsr-calculation-methods',
    meta: {
      // requiredPrivileges:  ['Loan-Pro Settings']
    },
    component: () =>
      import(
        '@/modules/global-settings/loan-origination/views/other-settings/DSRCalculationMethods.vue'
      )
  }
];
